import { registraGlobalComponents } from '@/app'

import VPicture        from './VPicture.vue'
import BtnWhatsappFixo from './BtnWhatsapp/BtnWhatsappFixo.vue'
import KCookies        from './KCoockies.vue'
import VAffix          from './VAffix.vue'
import KSlider         from './KSlider.vue'
import LogoKryzalis    from './LogoKryzalis.vue'
import VideoYtb        from './VideoYtb.vue'

registraGlobalComponents({
	VPicture,
	BtnWhatsappFixo,
	KCookies,
	VAffix,
	KSlider,
	LogoKryzalis,
	VideoYtb,
})
